import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import templatesSlice from './slices/templatesSlice';
import projectSlice from './slices/projectSlice';
import authSlice from './slices/authSlice';
import pageSlice from './slices/pageSlice';
import imageSlice from './slices/imageSlice';
import onboardingSlice from './slices/onboardingSlice';
import notesSlice from './slices/notesSlice';
import emailVerificationSlice from './slices/emailVerifySlice';
import logoSlice from './slices/logoSlice';
import navigationGuardReducer from './slices/navigationGuardSlice';
import dashboardSlice from './slices/dashboardSlice';
import { initialState as authInitialState } from './slices/authSlice';
import { initialState as emailInitialState } from './slices/emailVerifySlice';
import { initialState as imageInitialState } from './slices/imageSlice';
import { initialState as logoInitialState } from './slices/logoSlice';
import { initialState as notesInitialState } from './slices/notesSlice';
import { initialState as onboardingInitialState } from './slices/onboardingSlice';
import { initialState as pageInitialState } from './slices/pageSlice';
import { initialState as templatesInitialState } from './slices/templatesSlice';
import { initialState as projectInitialState } from './slices/projectSlice';
import { initialState as navigationGuardInitialState } from './slices/navigationGuardSlice';
import { initialState as dashboardInitialState } from './slices/dashboardSlice';
import toastReducer from './slices/toastSlice';
import { initialState as toastInitialState } from './slices/toastSlice';
import { subscriptionSlice } from './slices/subscriptionSlice';
import { initialState as subscriptionState } from './slices/subscriptionSlice';
import { initialState as socialState } from './slices/socialSlice';
import socialSlice from './slices/socialSlice';

const appReducer = combineReducers({
    templates: templatesSlice,
    project: projectSlice,
    auth: authSlice,
    page: pageSlice,
    image: imageSlice,
    onboarding: onboardingSlice,
    notes: notesSlice,
    emailVerification: emailVerificationSlice,
    logo: logoSlice,
    navigationGuard: navigationGuardReducer,
    toast: toastReducer,
    dashboard: dashboardSlice,
    subscription: subscriptionSlice.reducer,
    social: socialSlice,
});

const rootReducer = (state: any, action: any) => {
    if (action.type === 'RESET_APP') {
        return {
            auth: { ...authInitialState, accessToken: null, token: null },
            emailVerification: emailInitialState,
            image: imageInitialState,
            logo: logoInitialState,
            notes: notesInitialState,
            onboarding: onboardingInitialState,
            page: pageInitialState,
            templates: templatesInitialState,
            project: projectInitialState,
            navigationGuard: navigationGuardInitialState,
            toast: toastInitialState,
            dashboard: dashboardInitialState,
            subscription: subscriptionState,
            social: socialState,
        };
    }
    return appReducer(state, action);
};

const store = configureStore({
    reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
